/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { USAGE_TYPE } from '../../../../../../util/constants';

const PRODUCT_GROUP = 'ProductGroup';

const getProductLotRecord = (product: any, usageDetails: any, isCatalog = false): any => {
  let returnVal = null;
  if (usageDetails && usageDetails.lineItems && usageDetails.lineItems.length) {
    returnVal = !isCatalog
      ? usageDetails.lineItems.find(
          (rec: any) =>
            rec.productId === product.productId &&
            rec.lotNumber === product.lotNumber &&
            rec.caseUsageSubInventoryCode === product.subInventoryCode
        )
      : usageDetails.lineItems.find((rec: any) => rec.productId === product.productId);
  }
  return returnVal;
};

export const parseInventory = (inventory: any[], usageDetails: any, inventoryPartsToAdd: any[]) => {
  if (inventory?.length) {
    const finalSubInvWithLotInfo: any[] = [];
    const finalSubInvWithLotAccountInfo: any[] = [];
    const productDescriptionList: any[] = [];
    const repAccount: any[] = [];

    inventory.forEach((record: any) => {
      const productLot = getProductLotRecord(record, usageDetails);
      record.alreadyAdded = !!productLot;
      record.counterValue = productLot ? Number(productLot.quantity) : 0;
      record.changed = false;
      record.maxPermissibleValue = Number(record.availableQuantity) + record.counterValue;

      const changedIndex = inventoryPartsToAdd.find(
        (index: any) => index.lotNumber === record.lotNumber && index.productId === record.productId
      );
      if (changedIndex) record.counterValue = changedIndex.counterValue;

      const data = productDescriptionList?.filter(
        (item: any) =>
          item.prodNum === record.productNumber && item.subInventoryCode === record.subInventoryCode
      );
      if (data && data.length > 0) {
        const index = finalSubInvWithLotInfo.findIndex(
          (entry: any) =>
            entry.productNumber === record.productNumber &&
            entry.subInventoryCode === record.subInventoryCode
        );

        finalSubInvWithLotInfo[index].value.push(record);
      } else {
        finalSubInvWithLotInfo.push({
          name: record.productDescription,
          productNumber: record.productNumber,
          productOnHold: record.productOnHold,
          productOnHoldType: record.productOnHoldType,
          subInventoryCode: record.subInventoryCode,
          subInventoryName: record.subInventoryName,
          value: [record],
          isrepstock: record.isrepstock,
        });
        productDescriptionList.push({
          prodNum: record.productNumber,
          prodName: record.productDescription,
          subInventoryCode: record.subInventoryCode,
        });
      }
    });

    finalSubInvWithLotInfo.forEach((subInv: any) => {
      if (repAccount.map(e => e.subInventoryCode).indexOf(subInv.subInventoryCode) >= 0) {
        const index = finalSubInvWithLotAccountInfo.findIndex(
          (entry: any) => entry.subInventoryCode === subInv.subInventoryCode
        );
        finalSubInvWithLotAccountInfo[index]?.productDescription[0].value.push(subInv);
      } else {
        finalSubInvWithLotAccountInfo.push({
          subInventoryCode: subInv.subInventoryCode,
          subInventoryName: subInv.subInventoryName,
          name: subInv.name,
          productNumber: subInv.productNumber,
          productOnHold: subInv.productOnHold,
          productOnHoldType: subInv.productOnHoldType,
          isrepstock: subInv.isrepstock,
          productDescription: [
            {
              name: subInv.name,
              productNumber: subInv.productNumber,
              productOnHold: subInv.productOnHold,
              productOnHoldType: subInv.productOnHoldType,
              subInventoryCode: subInv.subInventoryCode,
              subInventoryName: subInv.subInventoryName,
              isrepstock: subInv.isrepstock,
              value: [subInv],
            },
          ],
        });
        repAccount.push({
          subInventoryCode: subInv.subInventoryCode,
          subInventoryName: subInv.subInventoryName,
        });
      }
    });

    return finalSubInvWithLotAccountInfo;
  }
  return [];
};

export const parseCatalog = (catalogItems: any[], usageDetails: any, catalogPartsToAdd: any[]) => {
  if (catalogItems?.length) {
    catalogItems.forEach((list: any) => {
      const record = getProductLotRecord(list, usageDetails, true);
      const changedIndex = catalogPartsToAdd.find(
        (index: any) => index.productId === list.productId
      );

      if (record && usageDetails?.diplayOrderType === USAGE_TYPE.SHIP_AND_BILL) {
        list.counterValue = Number(record.quantity);
        list.externalId = record.externalId;
        list.sfid = record.sfid;
      } else {
        list.counterValue = 0;
        list.externalId = null;
        list.sfid = null;
      }

      if (changedIndex) list.counterValue = changedIndex.counterValue;
      if (record) {
        list.usageExternalId = record.usageExternalId;
        list.alreadyAdded = true;
      }
      list.changed = false;
    });

    return catalogItems;
  }
  return [];
};

export const getCatalogQueryVariables = (
  usageDetails: any,
  userInfo: any,
  searchText = '',
  selectedGroup: any[] = []
) => {
  return {
    searchText,
    caseId: usageDetails.caseId ? usageDetails.caseId : null,
    caseExternalId: usageDetails.caseExternalId ? usageDetails.caseExternalId : null,
    salesRepId: usageDetails.salesRepId ? usageDetails.salesRepId : null,
    isReview: !!usageDetails?.isReview,
    filters: {
      businessUnit: [userInfo?.businessunit || 'Sports Med'],
      userId: userInfo?.id,
      productName: selectedGroup,
    },
  };
};

export const optionsWithLabel = (productGroups: any[]): any[] =>
  productGroups &&
  productGroups.map((elem: { __typename: string; name: any; number: any; value: any }) => {
    if (elem.__typename === PRODUCT_GROUP) {
      return { ...elem, label: `${elem.value}` };
    }
    return elem;
  });
